// The plan picked on the website (?plan=<Stripe lookup key> on /signup or /login), kept while the person signs in with Xero
const SELECTED_PLAN_KEY = 'selectedPlan';

export function rememberSelectedPlan(search: string) {
  const plan = new URLSearchParams(search).get('plan');
  if (plan) {
    try {
      localStorage.setItem(SELECTED_PLAN_KEY, plan);
    } catch {
      // Storage can be blocked, the person just picks the plan again
    }
  }
}

export function getSelectedPlan(): string | null {
  try {
    return localStorage.getItem(SELECTED_PLAN_KEY);
  } catch {
    return null;
  }
}

export function forgetSelectedPlan() {
  try {
    localStorage.removeItem(SELECTED_PLAN_KEY);
  } catch {
    // Nothing to forget
  }
}

/** One card per subscription level, named after the level. Levels sold in several sizes (Business + 150, 200, …) share a card, smallest first. */
export type PlanCard = { name: string; tiers: Plan[] };

export function groupPlans(plans: Plan[]): PlanCard[] {
  const byLevel = new Map<string, Plan[]>();
  [...plans].sort((a, b) => a.amount - b.amount).forEach(plan => byLevel.set(plan.level, [...(byLevel.get(plan.level) || []), plan]));
  return [...byLevel.values()].map(tiers => ({ name: tiers[0].levelName, tiers }));
}

export function formatPrice(plan: Plan) {
  return new Intl.NumberFormat('en-AU', { style: 'currency', currency: plan.currency.toUpperCase(), maximumFractionDigits: 0 }).format(plan.amount / 100);
}

export function checkoutUrl(plan: Plan) {
  return `/api/subscription/checkout-redirect?plan=${encodeURIComponent(plan.lookupKey)}`;
}

export function changePlanUrl(plan: Plan) {
  return `/api/subscription/change-plan-redirect?plan=${encodeURIComponent(plan.lookupKey)}`;
}
